export const ITEMS_PER_PAGE = {
  "10": 10,
  "25": 25,
  "50": 50,
  "100": 100,
};

export const ITEMS_PER_PAGE_KEY = 'filters_itemsPerPage'